import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';

export interface SharedCommentTableContainerDialogData {
    commentsList: {
        label: string;
        publicComment: string;
        privateComment?: string;
    }[];
}

@Component({
    selector: 'app-shared-comment-table-container-dialog',
    templateUrl: './shared-comment-table-container-dialog.component.html',
    styleUrls: ['./shared-comment-table-container-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedCommentTableContainerDialogComponent {

    constructor(private dialogRef: KalDialogRef<SharedCommentTableContainerDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: SharedCommentTableContainerDialogData) {
    }

    close(): void {
        this.dialogRef.close();
    }

}
